import { addListener, callbacks } from '../core/addListener'

export type IOnBackPressedParams = () => void

const clearPrevCallback = (type: string) => {
  if (callbacks[type] && callbacks[type].length !== 0) {
    callbacks[type] = []
  }
}

export function onBackPressed(callback: IOnBackPressedParams) {
  const type = 'onBackPressed'

  clearPrevCallback(type)
  addListener(type, callback)
}
